export default __webpack_public_path__ + "static/media/cherry.a32dbe12.jpeg";